import React from "react";
import "./EmptyState.css";

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  size?: number;
}

const DefaultIcon: React.FC<{ size?: number }> = ({ size = 56 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="12" width="3" height="8" rx="0.5" fill="#E6EEF3" />
    <rect x="9" y="8" width="3" height="12" rx="0.5" fill="#A7D3A8" />
    <rect x="15" y="4" width="3" height="16" rx="0.5" fill="#4CAF50" />
    <path d="M2 20h20" stroke="#CBD5E1" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No data",
  description,
  icon,
  size,
}) => {
  return (
    <div className="empty-state" role="region" aria-label={title}>
      <div className="empty-state-icon">{icon ?? <DefaultIcon size={size} />}</div>
      {title && <div className="empty-state-title">{title}</div>}
      {description && <div className="empty-state-desc">{description}</div>}
    </div>
  );
};

export default EmptyState;
